const module = { name: 'shared/global/globalOfferBanner', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_adobeLaunch as Fandango_adobeLaunch_track_EventTypes } from 'require-global';

const { track, EventTypes } = Fandango_adobeLaunch_track_EventTypes;


import { Fandango as Fandango_analyticsData } from 'require-core';

const { analyticsData: { loggedInStatus, pageName, pageType, platform, server, } = {} } = Fandango_analyticsData;


const Selectors = {
    OFFER_ITEM: '.js-global-offer-tracking',
    ARROW: '.js-global-offer-arrow',
}
function initTracking() {
    $(Selectors.ARROW).on('click', () => track({
        event: EventTypes.GLOBAL_OFFER_ARROW_CLICK,
        loggedInStatus,
        pageName,
        pageType,
        platform,
        server,
    }));
    $(Selectors.OFFER_ITEM).on('click', (e) => {
        const { promoLink, promoName, promoPosition } = e.currentTarget.dataset;
        track({
            event: EventTypes.GLOBAL_OFFER_CLICK,
            navPromoLink: promoLink,
            navPromoName: promoName,
            navPromoPosition: promoPosition,
            loggedInStatus,
            pageName,
            pageType,
            platform,
            server,
        });
    });
}
module.exports = {
    initTracking,
};
export default module.exports;